import React from 'react';
import Select from 'react-select';

import { InputClassProps } from '../input-class-name.util';
import { Option } from './option.model';
import {
  Control,
  DropdownIndicator,
  LoadingIndicator,
  LoadingMessage,
  MultiValueContainer,
  MultiValueLabel,
  MultiValueRemove,
  NoOptionsMessage,
  Option as OptionComponent,
  Placeholder,
  ValueContainer,
} from './ui';

export type SearchSelectProps = {
  options: Option[];
  value?: Option[];
  placeholder?: string;
  inputId?: string;
  isLoading?: boolean;
  isDisabled?: boolean;
  isMulti?: boolean;
  loadingMessage?: React.ReactNode;
  noOptionsMessage?: React.ReactNode;
  onChange: (values: ReadonlyArray<Option>) => void;
} & InputClassProps;

export const SearchSelect = ({
  options,
  value,
  placeholder,
  inputId,
  isLoading,
  variant = 'default',
  height = 'md',
  isDisabled,
  isMulti = true,
  loadingMessage,
  noOptionsMessage,
  onChange,
  ...rest
}: SearchSelectProps) => {
  const inputProps: InputClassProps = {
    variant,
    height,
    ...rest,
  };

  return (
    <Select<Option, true>
      components={{
        LoadingIndicator,
        MultiValueContainer,
        IndicatorSeparator: null,
        LoadingMessage: (props) => (
          <LoadingMessage loadingMessage={loadingMessage} {...props} />
        ),
        NoOptionsMessage: (props) => (
          <NoOptionsMessage noOptionsMessage={noOptionsMessage} {...props} />
        ),
        Option: (props) => <OptionComponent isMultiple={isMulti} {...props} />,
        Control: (props) => <Control {...inputProps} {...props} />,
        ValueContainer: (props) => (
          <ValueContainer {...inputProps} {...props} />
        ),
        MultiValueLabel: (props) => (
          <MultiValueLabel {...inputProps} {...props} />
        ),
        MultiValueRemove: (props) => (
          <MultiValueRemove {...inputProps} {...props} />
        ),
        DropdownIndicator: (props) => (
          <DropdownIndicator {...inputProps} {...props} />
        ),
        Placeholder: (props) => <Placeholder {...props} />,
      }}
      isMulti={isMulti ? true : undefined}
      hideSelectedOptions={false}
      isClearable={false}
      closeMenuOnSelect={isMulti ? false : true}
      tabSelectsValue={false}
      options={options}
      value={value}
      placeholder={placeholder}
      inputId={inputId}
      isLoading={isLoading}
      isDisabled={isDisabled}
      onChange={onChange}
    />
  );
};
